var _path, _path2, _path3, _g, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAreacomum = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 108,
  height: 106,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.11 56.573c2.29 3.864 2.83 8.472 2.875 12.943.114 11.079-8.017 27.234-15.233 35.718l12.266.102s21.327-22.089 7.33-55.817",
  fill: "#ACACAC"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M22.11 56.573c2.29 3.864 2.83 8.472 2.875 12.943.114 11.079-8.017 27.234-15.233 35.718l12.266.102s21.327-22.089 7.33-55.817",
  fill: "url(#paint0_linear)"
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.627 51.908a17.026 17.026 0 0116.802-3.51 12.534 12.534 0 00-17.18-1.486c1.119-2.86 3.2-5.241 5.887-6.735a19.646 19.646 0 018.716-2.458 11.65 11.65 0 00-10.789-.583 18.084 18.084 0 00-8.109 7.523 19.132 19.132 0 012.863-6.86 9.36 9.36 0 016.15-3.967 11.552 11.552 0 00-11.36 2.035 11.037 11.037 0 00-3.94 10.553 15.212 15.212 0 00-13.882 4.62A15.162 15.162 0 00.612 65.32a16.752 16.752 0 014.146-7.695 10.675 10.675 0 017.926-3.293 13.296 13.296 0 00-5.91 9.147A19.669 19.669 0 008.4 74.466a21.314 21.314 0 012.2-9.592 13.986 13.986 0 017.089-6.655 13.929 13.929 0 001.775 16.487 21.349 21.349 0 012.52-15.846l6.643-6.952z",
  fill: "#EE8322"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M28.627 51.908a17.026 17.026 0 0116.802-3.51 12.534 12.534 0 00-17.18-1.486c1.119-2.86 3.2-5.241 5.887-6.735a19.646 19.646 0 018.716-2.458 11.65 11.65 0 00-10.789-.583 18.084 18.084 0 00-8.109 7.523 19.132 19.132 0 012.863-6.86 9.36 9.36 0 016.15-3.967 11.552 11.552 0 00-11.36 2.035 11.037 11.037 0 00-3.94 10.553 15.212 15.212 0 00-13.882 4.62A15.162 15.162 0 00.612 65.32a16.752 16.752 0 014.146-7.695 10.675 10.675 0 017.926-3.293 13.296 13.296 0 00-5.91 9.147A19.669 19.669 0 008.4 74.466a21.314 21.314 0 012.2-9.592 13.986 13.986 0 017.089-6.655 13.929 13.929 0 001.775 16.487 21.349 21.349 0 012.52-15.846l6.643-6.952z",
  fill: "url(#paint1_linear)"
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.377 105.645H8.835s33.605-20.66 44.99-72.373l14.51.343s.86 24.856-30.958 72.03z",
  fill: "#D7D8D6"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 8,
  y: 33,
  width: 61,
  height: 73
}, /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M37.377 105.645H8.835s33.605-20.66 44.99-72.373l14.51.343s.86 24.856-30.958 72.03z",
  fill: "url(#paint2_linear)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)",
  stroke: "#ACACAC",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.807 38.142h24.945M38.569 45.494h32.184M38.569 52.846h32.184M38.569 60.197h32.184M38.569 67.56h32.184M24.802 74.912h45.95M24.802 82.264h45.95M8.286 89.627h62.466M8.286 96.978h62.466"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.926 56.218c-2.2 3.75-2.749 8.233-2.795 12.577-.103 10.77 10.09 28.31 17.043 36.587H77.098s-20.811-23.244-7.239-56.024",
  fill: "#ACACAC"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M76.926 56.218c-2.2 3.75-2.749 8.233-2.795 12.577-.103 10.77 10.09 28.31 17.043 36.587H77.098s-20.811-23.244-7.239-56.024",
  fill: "url(#paint3_linear)"
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M68.714 52.228c-.848-4.688-5.727-5.236-10.48-5.82-4.754-.583-9.438.892-13.94 2.459a16.22 16.22 0 015.31-6.291 16.258 16.258 0 0115.86-1.608 16.236 16.236 0 016.468 5.098 14.953 14.953 0 00-2.609-6.374 14.984 14.984 0 00-5.19-4.534 22.403 22.403 0 00-13.55-2.184 21.287 21.287 0 0126.434 2.984c2.52 2.676 4.353 6.403 3.436 9.97 4.17-2.412 9.701-1.806 13.87.606a17.353 17.353 0 018.018 11.536 16.447 16.447 0 00-8.302-6.312 16.474 16.474 0 00-10.436-.056 15.453 15.453 0 015.17 3.442 15.42 15.42 0 014.46 11.308 15.4 15.4 0 01-1.43 6.036c-2.565-6.734-8.017-16.258-15.84-14.863l-7.25-5.397z",
  fill: "#AC41D8"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M68.714 52.228c-.848-4.688-5.727-5.236-10.48-5.82-4.754-.583-9.438.892-13.94 2.459a16.22 16.22 0 015.31-6.291 16.258 16.258 0 0115.86-1.608 16.236 16.236 0 016.468 5.098 14.953 14.953 0 00-2.609-6.374 14.984 14.984 0 00-5.19-4.534 22.403 22.403 0 00-13.55-2.184 21.287 21.287 0 0126.434 2.984c2.52 2.676 4.353 6.403 3.436 9.97 4.17-2.412 9.701-1.806 13.87.606a17.353 17.353 0 018.018 11.536 16.447 16.447 0 00-8.302-6.312 16.474 16.474 0 00-10.436-.056 15.453 15.453 0 015.17 3.442 15.42 15.42 0 014.46 11.308 15.4 15.4 0 01-1.43 6.036c-2.565-6.734-8.017-16.258-15.84-14.863l-7.25-5.397z",
  fill: "url(#paint4_linear)"
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M105.674 31.5c-.241-.595-.493-1.144-.745-1.796-3.287-7.786-11.282-12.05-19.47-12.576-2.301-.147-4.61.002-6.873.446-2.233.434-4.272 1.577-6.402 2.058 2.92-4.871 10.87-7.935 16.23-8.541a21.545 21.545 0 0117.443 5.717c-2.692-6.86-9.655-11.594-16.928-12.829-7.273-1.235-14.89.652-21.498 4.025a18.676 18.676 0 00-6.735 5.26c-2.68-3.66-5.646-7.227-9.54-9.536A25.655 25.655 0 0039.048.458a35.552 35.552 0 00-20.78 5.798A35.456 35.456 0 004.69 22.993c5.83-5.03 12.484-9.455 20.043-10.919 7.56-1.463 16.161.583 20.949 6.597A30.768 30.768 0 0018.284 22.8a30.678 30.678 0 00-9.237 10.856A30.621 30.621 0 005.72 47.506a39.956 39.956 0 0111.79-13.711 40.042 40.042 0 0116.637-7.12 24.32 24.32 0 019.048 0 31.007 31.007 0 00-13.492 10.618 30.927 30.927 0 00-5.76 16.159c6.08-10.302 18.084-17.974 29.881-20.18 1.145.103 14.74.388 14.775.354 4.215-.114 9.3 1.91 12.759 4.402 5.234 3.784 9.884 8.815 11.568 15.046 1.626-8.209-.458-19.173-9.838-25.153 4.715-.19 9.405.78 13.658 2.82a28.843 28.843 0 0110.737 8.888 18.809 18.809 0 00-1.809-8.13z",
  fill: "#00D38D"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M105.674 31.5c-.241-.595-.493-1.144-.745-1.796-3.287-7.786-11.282-12.05-19.47-12.576-2.301-.147-4.61.002-6.873.446-2.233.434-4.272 1.577-6.402 2.058 2.92-4.871 10.87-7.935 16.23-8.541a21.545 21.545 0 0117.443 5.717c-2.692-6.86-9.655-11.594-16.928-12.829-7.273-1.235-14.89.652-21.498 4.025a18.676 18.676 0 00-6.735 5.26c-2.68-3.66-5.646-7.227-9.54-9.536A25.655 25.655 0 0039.048.458a35.552 35.552 0 00-20.78 5.798A35.456 35.456 0 004.69 22.993c5.83-5.03 12.484-9.455 20.043-10.919 7.56-1.463 16.161.583 20.949 6.597A30.768 30.768 0 0018.284 22.8a30.678 30.678 0 00-9.237 10.856A30.621 30.621 0 005.72 47.506a39.956 39.956 0 0111.79-13.711 40.042 40.042 0 0116.637-7.12 24.32 24.32 0 019.048 0 31.007 31.007 0 00-13.492 10.618 30.927 30.927 0 00-5.76 16.159c6.08-10.302 18.084-17.974 29.881-20.18 1.145.103 14.74.388 14.775.354 4.215-.114 9.3 1.91 12.759 4.402 5.234 3.784 9.884 8.815 11.568 15.046 1.626-8.209-.458-19.173-9.838-25.153 4.715-.19 9.405.78 13.658 2.82a28.843 28.843 0 0110.737 8.888 18.809 18.809 0 00-1.809-8.13z",
  fill: "url(#paint5_linear)"
}), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 9.752,
  y1: 77.427,
  x2: 34.102,
  y2: 77.427,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: -0.006,
  y1: 53.898,
  x2: 45.395,
  y2: 53.898,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EE8322"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#F19A4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#F4B276"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#F7C79B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#FAD8BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#FCE6D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#FDF1E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#FEF9F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#FFFEFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 468.196,
  y1: 4399.56,
  x2: 3559.95,
  y2: 4399.56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 1542.17,
  y1: 3816.95,
  x2: 2128.01,
  y2: 3816.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 44.272,
  y1: 51.073,
  x2: 102.283,
  y2: 51.073,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#AF47D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#B658DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#C375E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#D49CEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EACEF5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 4.643,
  y1: 26.96,
  x2: 107.449,
  y2: 26.96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAreacomum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/areacomum.ec74c89841e4803c687993dfe2baef02.svg";